import auth from '@/middleware/modules/auth'

const Creator = () => import(/* webpackChunkName: "_v-creators" */ '@/views/creators/Creator.vue')
const CreatorAnalyticsTiktok = () => import(/* webpackChunkName: "_v-creators" */ '@/views/creators/Tabs/AnalyticsTiktok.vue')
const CreatorAnalyticsInstagram = () => import(/* webpackChunkName: "_v-creators" */ '@/views/creators/Tabs/AnalyticsInstagram.vue')
const CreatorAnalyticsFacebook = () => import(/* webpackChunkName: "_v-creators" */ '@/views/creators/Tabs/AnalyticsFacebook.vue')

export default [
  {
    path: 'campaign/creator/:creator_id(\\d+)',
    name: 'campaign-creator',
    component: Creator,
    redirect: { name: 'campaign-creator-instagram' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
    children: [
      {
        path: 'instagram',
        name: 'campaign-creator-instagram',
        component: CreatorAnalyticsInstagram,
        meta: {
          layout: 'app-layout',
          tab: 'creator-instagram',
          middleware: [auth],
        },
      },
      {
        path: 'tiktok',
        name: 'campaign-creator-tiktok',
        component: CreatorAnalyticsTiktok,
        meta: {
          layout: 'app-layout',
          tab: 'creator-tiktok',
          middleware: [auth],
        },
      },
      {
        path: 'facebook',
        name: 'campaign-creator-facebook',
        component: CreatorAnalyticsFacebook,
        meta: {
          layout: 'app-layout',
          tab: 'creator-facebook',
          middleware: [auth],
        },
      },
    ],
  },
]
